import React from 'react';
import './App.css';
import 'antd/dist/antd.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles'
import deepOrange from '@material-ui/core/colors/deepOrange';
import green from '@material-ui/core/colors/green';

// Components
import ChatArea from './components/ChatArea';
//import FabPopup from './components/FabPopup';

let theme = createMuiTheme({
  palette: {
    primary: {
      main: deepOrange[500],
    },
    secondary: {
      main: green[500],
    },
  },
});
theme = responsiveFontSizes(theme);

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <ChatArea/>
        {/*<FabPopup/>*/}
      </ThemeProvider>  
    </div>
  );
}

export default App;
